import { getCookieByName } from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import { AnchorTag, FlexComp, ImageComponent, SpanTag } from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";
import React, { useEffect, useState } from "react";
import FormattedText, { TextNodeType } from "../FormattedText/FormattedText";
import { LandingHeaderMob, LandingHeaderMobBlack } from "./LandingHeader.style";
import { LandingHeaderBackButton } from "./LandingHeaderBackButton";
interface LandingHeaderProps {
  handleBackBtn?: () => void;
  headerTitle?: string | TextNodeType;
  children?: React.ReactNode;
  goToMyOrders?: () => void;
  myOrders?: boolean;
  displayWhiteHeader?: boolean;
  partnerType?: string;
  insuranceHeader?: boolean;
  exitWebViewOnBack?: boolean;
  showPwaHeaderBackButton?: boolean;
}

const LandingHeaderMobile = ({
  handleBackBtn,
  headerTitle,
  children,
  myOrders,
  goToMyOrders,
  displayWhiteHeader,
  partnerType,
  insuranceHeader,
  exitWebViewOnBack,
  showPwaHeaderBackButton = true,
}: LandingHeaderProps) => {
  const [isScrolledPast40, setIsScrolledPast40] = useState(false);
  const device = useBreakpointV2();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const shouldShowWhiteHeader = currentScrollPos > 40;

      // Only update state if the threshold crossing state has changed
      if (shouldShowWhiteHeader !== isScrolledPast40) {
        setIsScrolledPast40(shouldShowWhiteHeader);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolledPast40]);

  useEffect(() => {
    const authCookie =
      getCookieByName("mmt-auth") || getCookieByName("OAUTH-GOIBIBO");
    setIsLoggedIn(!!authCookie);
  }, []);

  const blackHeaderStyle = {
    display: isScrolledPast40 ? "none" : "block",
  };

  const whiteHeaderStyle = {
    display: isScrolledPast40 ? "block" : "none",
  };

  return (
    <React.Fragment>
      <LandingHeaderMobBlack
        displayWhiteHeader={displayWhiteHeader}
        id="blackHeader"
        style={blackHeaderStyle}
        insuranceHeader={insuranceHeader}
      >
        <FlexComp
          gap="12px"
          alignItems="center"
          justifyContent={displayWhiteHeader ? "flex-start" : "space-between"}
        >
          <LandingHeaderBackButton
            handleBackBtn={handleBackBtn}
            showPwaHeaderBackButton={showPwaHeaderBackButton}
            exitWebViewOnBack={exitWebViewOnBack}
          />
          {headerTitle && displayWhiteHeader && (
            <SpanTag fontSize="md" fontWeight="bold">
              <FormattedText value={headerTitle} />
            </SpanTag>
          )}
          {device == "sm" && myOrders && (
            <ImageComponent
              width="75px"
              height="24px"
              src={
                partnerType === PARTNER.MMT
                  ? "https://tripmoneycmsimgak.mmtcdn.com/img/Group_46_699159e12c.svg"
                  : "https://tripmoneycmsimgak.mmtcdn.com/img/gi_logo_512_6736e70735.png"
              }
            />
          )}
          {myOrders && isLoggedIn ? (
            <AnchorTag
              color={`var(--tm-accent-color)`}
              fontWeight="bold"
              handleClick={goToMyOrders}
            >
              My Orders
            </AnchorTag>
          ) : (
            <div style={{ width: "24px", height: "24px" }} />
          )}
        </FlexComp>
        {children}
      </LandingHeaderMobBlack>
      <LandingHeaderMob id="whiteHeader" style={whiteHeaderStyle}>
        <FlexComp gap="12px" alignItems="center">
          <LandingHeaderBackButton
            handleBackBtn={handleBackBtn}
            displayWhiteHeader={true}
            exitWebViewOnBack={exitWebViewOnBack}
          />
          {headerTitle && (
            <SpanTag fontSize="md" fontWeight="bold">
              <FormattedText value={headerTitle} />
            </SpanTag>
          )}
          {myOrders && isLoggedIn ? (
            <AnchorTag
              color={`var(--tm-accent-color)`}
              margin="0 0 0 auto"
              fontWeight="bold"
              handleClick={goToMyOrders}
            >
              My Orders
            </AnchorTag>
          ) : (
            <div style={{ width: "24px", height: "24px" }} />
          )}
        </FlexComp>
        {children}
      </LandingHeaderMob>
    </React.Fragment>
  );
};

export default LandingHeaderMobile;
